import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetSearchingResultsFailed, EGetSearchingResultsActionType } from './types';

export const getSearchingResultsFailed: () => TGetSearchingResultsFailed =
  actionGenerator<EGetSearchingResultsActionType.Failed>(EGetSearchingResultsActionType.Failed);
